import { render } from "./tickets-list-draft.vue?vue&type=template&id=1240307c"
import script from "./tickets-list-draft.vue?vue&type=script&lang=js"
export * from "./tickets-list-draft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__